import {SUPPORTED_REGIONS, SUPPORTED_REGION_CODES} from "./region";
import {LocalizedValue} from "./locale";

export type SubscriptionPlan = {
    id?: string,
    _id?:string,
    name?: string,
    billingFrequency?: number,
    frequencyLabel?: "weekly" | "monthly" | "quarterly" | "yearly",
    isLifetime?: boolean,
    isTrial?: boolean,
    validity?: number,
    price?: number,
    regions?: typeof SUPPORTED_REGION_CODES | "ALL",
    localizedPrice?: string,
    isPopular?: boolean,
    currencyCode?: string,
    features?: LocalizedValue<string>[],
}

export type Subscription = SubscriptionPlan & {
    hasExpired?: boolean,
    subscribedAt?: number,
}

export const DEFAULT_SUBSCRIPTION_PLANS: Subscription[] = [
    {
        "_id": "952039d5-a79d-48f6-ad8c-391ee797497e",
        "name": "Infinity",
        "price": 25,
        "validity": 180,
        "regions": [
            "BJ",
            "BF",
            "CV",
            "CI",
            "GM",
            "GH",
            "GN",
            "GW",
            "LR",
            "ML",
            "MR",
            "NE",
            "NG",
            "SN",
            "SL",
            "TG",
            "AO",
            "CM",
            "CF",
            "TD",
            "CG",
            "CD",
            "GQ",
            "GA",
            "ST"
        ],
        "features": [
            {
                "en": "Full access",
                "fr": "Accès complet"
            },
            {
                "en": "Multiple device support",
                "fr": "Prise en charge de plusieurs appareils"
            },
            {
                "en": "Multiple language exam support",
                "fr": "Soutien aux examens de langues multiples"
            },
            {
                "en": "Expires after 180 days",
                "fr": "Expire après 180 jours"
            }
        ],
         "localizedPrice": "FCFA 14,400.00",
        "currencyCode": "XAF"
    },
    {
        "_id": "9e9d8f6e-58a6-4938-b66b-cb144949b225",
        "name": "Extended",
        "price": 15,
        "validity": 90,
        "regions": [
            "BJ",
            "BF",
            "CV",
            "CI",
            "GM",
            "GH",
            "GN",
            "GW",
            "LR",
            "ML",
            "MR",
            "NE",
            "NG",
            "SN",
            "SL",
            "TG",
            "AO",
            "CM",
            "CF",
            "TD",
            "CG",
            "CD",
            "GQ",
            "GA",
            "ST"
        ],
        "features": [
            {
                "en": "Full access",
                "fr": "Accès complet"
            },
            {
                "en": "Multiple devices",
                "fr": "Plusieurs appareils"
            },
            {
                "en": "Single language exam",
                "fr": "Un examen de langue"
            },
            {
                "en": "Expires after 90 days",
                "fr": "Expire après 90 jours"
            }
        ],
        "localizedPrice": "FCFA 8,650.00",
        "currencyCode": "XAF"
    },
    {
        "_id": "efcf8219-9878-4de5-8b40-8406e0c80a35",
        "name": "Basic",
        "price": 3,
        "validity": 14,
        "regions": [
            "BJ",
            "BF",
            "CV",
            "CI",
            "GM",
            "GH",
            "GN",
            "GW",
            "LR",
            "ML",
            "MR",
            "NE",
            "NG",
            "SN",
            "SL",
            "TG",
            "AO",
            "CM",
            "CF",
            "TD",
            "CG",
            "CD",
            "GQ",
            "GA",
            "ST"
        ],
        "features": [
            {
                "en": "Full access",
                "fr": "Accès complet"
            },
            {
                "en": "Multiple devices",
                "fr": "Plusieurs appareils"
            },
            {
                "en": "Single language exam",
                "fr": "Un examen de langue"
            },
            {
                "en": "Expires after 14 days",
                "fr": "Expire après 14 jours"
            }
        ],
        "localizedPrice": "FCFA 1,750.00",
        "currencyCode": "XAF"
    },
    {
        "_id": "183447a2-f51c-4c39-8807-7342504adc67",
        "name": "Advanced",
        "price": 6,
        "validity": 30,
        "regions": [
            "BJ",
            "BF",
            "CV",
            "CI",
            "GM",
            "GH",
            "GN",
            "GW",
            "LR",
            "ML",
            "MR",
            "NE",
            "NG",
            "SN",
            "SL",
            "TG",
            "AO",
            "CM",
            "CF",
            "TD",
            "CG",
            "CD",
            "GQ",
            "GA",
            "ST"
        ],
        "features": [
            {
                "en": "Full access",
                "fr": "Accès complet"
            },
            {
                "en": "Multiple devices",
                "fr": "Plusieurs appareils"
            },
            {
                "en": "Single language exam",
                "fr": "Un examen de langue"
            },
            {
                "en": "Expires after 30 days",
                "fr": "Expire après 30 jours"
            }
        ],
        "localizedPrice": "FCFA 3,450.00",
        "currencyCode": "XAF"
    },
    {
        "_id": "3c165a4f-97d1-4973-8531-4293ecbe3a70",
        "features": [
            {
                "en": "Full access",
                "fr": "Accès complet"
            },
            {
                "en": "Single device",
                "fr": "Un appareil"
            },
            {
                "en": "Single language exam",
                "fr": "Un examen de langue"
            },
            {
                "en": "Expires after 3 days",
                "fr": "Expire après 3 jours"
            }
        ],
        "regions": [
            "BJ",
            "BF",
            "CV",
            "CI",
            "GM",
            "GH",
            "GN",
            "GW",
            "LR",
            "ML",
            "MR",
            "NE",
            "NG",
            "SN",
            "SL",
            "TG",
            "AO",
            "CM",
            "CF",
            "TD",
            "CG",
            "CD",
            "GQ",
            "GA",
            "ST"
        ],
        "name": "Free Trial",
        "isTrial": true,
        "id": "3c165a4f-97d1-4973-8531-4293ecbe3a70",
        "validity": 3,
        "localizedPrice": "FCFANaN",
        "currencyCode": "XAF"
    }
]


export const BILLING_FREQUENCIES_LABEL_MAP = [{
    label: 'Monthly',
    value: 30
}, {
    label: 'Weekly',
    value: 7
}, {
    label: 'Quarterly',
    value: 90
}, {
    label: 'Yearly',
    value: 365
}]